import { useEffect, useState } from "react";
import { MessageSquareHeart, Star, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

export const Stars = ({ value, onChange, size = "h-5 w-5", testId = "feedback-star" }) => (
  <div className="flex items-center gap-0.5" data-testid={`${testId}s`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" disabled={!onChange} data-testid={`${testId}-${n}`} onClick={() => onChange?.(n)} className={`${onChange ? "transition-transform hover:scale-110" : ""}`} aria-label={`${n} star${n === 1 ? "" : "s"}`}>
        <Star className={`${size} ${n <= value ? "fill-[#f5a524] text-[#f5a524]" : "text-white/20"}`} />
      </button>
    ))}
  </div>
);

// Customer dashboard: leave a review / feedback for the owner
export const FeedbackSection = ({ Section, open }) => {
  const [rating, setRating] = useState(0);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [mine, setMine] = useState([]);
  const load = () => api.myFeedback().then(setMine).catch(() => {});
  useEffect(() => { if (open) load(); }, [open]);
  const submit = async () => {
    if (!rating) return toast.error("Pick a star rating");
    if (message.trim().length < 3) return toast.error("Tell us a little more");
    setBusy(true);
    try { await api.leaveFeedback({ rating, message: message.trim() }); toast.success("Thank you! Your feedback was sent to the Xpattern team."); setRating(0); setMessage(""); load(); }
    catch (e) { toast.error(apiError(e, "Could not send feedback")); }
    setBusy(false);
  };
  return (
    <Section icon={MessageSquareHeart} title="Feedback / Review" testId="profile-feedback" className="mt-4">
      <p className="text-[11px] text-[#9aa0a8]">How is Xpattern working for your shop? Ideas, problems or a quick review — the owner reads every one.</p>
      <div className="flex items-center gap-3"><Stars value={rating} onChange={setRating} /><span className="text-[11px] text-[#6b7079]" data-testid="feedback-rating-label">{rating ? ["", "Poor", "Fair", "Good", "Great", "Excellent"][rating] : "Tap to rate"}</span></div>
      <textarea data-testid="feedback-message" value={message} onChange={(e) => setMessage(e.target.value)} maxLength={2000} rows={3} placeholder="What's working well? What should we improve?" className="field min-h-[72px] resize-y text-[12px]" />
      <div className="flex justify-end"><button data-testid="feedback-submit-btn" className="btn-red" disabled={busy} onClick={submit}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Send feedback</button></div>
      {mine.length > 0 && (
        <div className="scroll-visible max-h-40 overflow-y-auto rounded-lg border border-white/10 bg-black/25" data-testid="my-feedback">
          {mine.map((f) => (
            <div key={f.id} className="border-b border-white/10 px-3 py-2 text-[12px] last:border-b-0" data-testid={`my-feedback-${f.id}`}>
              <div className="flex items-center gap-2"><Stars value={f.rating} size="h-3 w-3" testId={`my-feedback-${f.id}-star`} /><span className="text-[10px] text-[#6b7079]">{new Date(f.created_at).toLocaleDateString()}</span></div>
              <p className="mt-0.5 whitespace-pre-wrap text-[#c9ccd2]">{f.message}</p>
            </div>
          ))}
        </div>
      )}
    </Section>
  );
};
